import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export function deficiencyClassTypesReducer(state = initialstate.deficiencyClassTypes, action) {
	if (action.type !== types.LIST_DEFICIENCY_CLASS_TYPES) {
		return state;
	}

	if (!isApiResponseOk(action)) {
		return state;
	}

	return action.response;
}
